import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Calendar, Settings } from 'lucide-react';
export function MechanismSection() {
  return <section className="w-full py-28 px-4 bg-brand-bg border-b border-brand-card overflow-hidden" data-id="element-91">
      <div className="max-w-4xl mx-auto text-center" data-id="element-92">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-93">
          <div className="inline-flex items-center justify-center p-3 bg-brand-card rounded-full mb-8 border border-brand-accent/20" data-id="element-94">
            <Settings className="w-6 h-6 text-brand-accent mr-2" data-id="element-95" />
            <span className="text-brand-accent font-bold uppercase tracking-wider text-sm" data-id="element-96">
              The Unique Mechanism
            </span>
          </div>

          <h2 className="text-4xl md:text-5xl font-serif font-bold text-white mb-8" data-id="element-97">
            You don't need a marriage counselor.
            <br data-id="element-98" />
            You need an{' '}
            <span className="text-brand-highlight underline decoration-brand-highlight/30 underline-offset-8" data-id="element-99">
              Operating Procedure.
            </span>
          </h2>

          <p className="text-xl text-brand-text-muted mb-12 max-w-2xl mx-auto" data-id="element-100">
            Introducing{' '}
            <strong className="text-white" data-id="element-101">The Home-All-Day Reset</strong>. This
            isn't about "fixing her" or "changing you." It’s about
            re-engineering the way you live under the same roof.
          </p>

          <div className="grid md:grid-cols-2 gap-8 mt-16" data-id="element-102">
            <div className="bg-brand-card p-8 rounded-xl border border-brand-bg-alt hover:border-brand-accent/50 transition-colors duration-300 text-left" data-id="element-103">
              <Shield className="w-12 h-12 text-brand-accent mb-6" data-id="element-104" />
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-105">
                3-Zone Protocol
              </h3>
              <p className="text-brand-text-muted" data-id="element-106">
                Creates immediate, physical boundaries that allow you to be a
                couple without losing your individual identity.
              </p>
            </div>

            <div className="bg-brand-card p-8 rounded-xl border border-brand-bg-alt hover:border-brand-accent/50 transition-colors duration-300 text-left" data-id="element-107">
              <Calendar className="w-12 h-12 text-brand-accent mb-6" data-id="element-108" />
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-109">
                2-Calendar System
              </h3>
              <p className="text-brand-text-muted" data-id="element-110">
                A tactical framework to manage time and "proximity friction"
                without endless discussions or therapy sessions.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}